import { render, staticRenderFns } from "./Nobilium.vue?vue&type=template&id=0ff572d7&scoped=true&"
import script from "./Nobilium.vue?vue&type=script&lang=js&"
export * from "./Nobilium.vue?vue&type=script&lang=js&"
import style0 from "./Nobilium.vue?vue&type=style&index=0&id=0ff572d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff572d7",
  null
  
)

export default component.exports